import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=5035fbc6&scoped=true"
import script from "./wechatBind.vue?vue&type=script&lang=js"
export * from "./wechatBind.vue?vue&type=script&lang=js"
import style0 from "./wechatBind.vue?vue&type=style&index=0&id=5035fbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035fbc6",
  null
  
)

export default component.exports